export enum ModalTypes {
  MODAL_AUTH__OPEN = 'MODAL_AUTH__OPEN',
  MODAL__CLEAR = 'MODAL__CLEAR',
  MODAL__CLOSE = 'MODAL__CLOSE',
  MODAL__OPEN = 'MODAL__OPEN',
}
